import styled from 'styled-components';
import { spacing, colors, Overline, Subtitle1, borderRadius } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const UnscoredMessagingActivityCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.plusHalf};
  padding: ${spacing.plusHalf};
  background-color: ${colors.backgroundSecondary};
  border-radius: ${borderRadius.lg};
  height: 100%;
  width: ${pxToRem(560)};
`;

export const UnscoredMessagingActivityMetricsContainer = styled.div`
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 1fr 1fr;

  & > *:not(:nth-last-child(-n + 2)) {
    padding-bottom: ${spacing.base};
    margin-bottom: ${spacing.base};
    border-bottom: ${spacing.single} solid ${colors.grey15};
  }

  & > *:nth-child(even) {
    text-align: end;
  }
`;

export const UnscoredMessagingActivityTitle = styled(Overline)`
  margin: 0;
  color: ${colors.textSecondary};
`;

export const SubtitleBold = styled(Subtitle1)`
  margin: 0;
`;
